import ReactDOM from 'react-dom/client';
import App from './App';
import './css/style.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
